export const getTimeZoneText = tzoffset =>
{
	let  tzNumber = parseInt(tzoffset), tzCode = "";

	tzCode += tzNumber < 0 ? "-" : "+";

	tzNumber = Math.abs(tzNumber);

	tzCode += tzNumber < 10 ? "0" + tzNumber : tzNumber;

	return tzCode + ":00";
}